__turbopack_context__.v({
  "container": "clp-subscription-unpause-module-scss-module__0ZudYq__container",
  "text": "clp-subscription-unpause-module-scss-module__0ZudYq__text",
});
